export interface VenueFilterType {
  selectedVenues: server.dto.VenueSmall[]
}

export const getVenueLabels = (filter: VenueFilterType) => {
  return filter.selectedVenues.map((a) => a.name)
    .sort((a, b) => a.localeCompare(b));
};

export const initialVenueFilter: VenueFilterType = {
  selectedVenues: []
};
